import client from './api-client';

export const serviceGetComboMonedas = async (query) => {
    try {
        // Cuando se cambie de modulo cambiar --client.getImplicado por client.get---
        const response = await client.getImplicado(`monedas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetMovimientos = async (query) => {
    try {
        // Cuando se cambie de modulo cambiar --client.getSelect por client.get---
        const response = await client.getSelect(`gestion-implicado/movimientos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetInforme = async (query) => {
    try {
        // Cuando se cambie de modulo cambiar --client.getDoc por client.getDocumento---
        const response = await client.getDoc(`get-file?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}